import { ReactNode, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { serviceEnvironment, viteSegmentApiWriteKey } from '../constants'
import { Tracker, type SegmentAnalyticsClient } from './Tracker'
import { TrackerContext } from './context'
import { TrackerLabraAuthProviderBinding } from './TrackerLabraAuthProviderBinding'

type TrackerProviderRootState = {
  AccountData?: {
    user?: {
      partnerData?: {
        isInternal?: boolean
      }
    }
  }
  userProfile?: {
    userProfile?: {
      email?: string
    }
  }
}

export const TrackerProvider = ({
  children,
  analytics,
}: {
  children: ReactNode
  analytics?: SegmentAnalyticsClient
}) => {
  const [tracker, setTracker] = useState(() => new Tracker(analytics))

  const isInternal = useSelector(
    (state: TrackerProviderRootState) =>
      state.AccountData?.user?.partnerData?.isInternal
  )

  const loggedInUserEmail = useSelector(
    (state: TrackerProviderRootState) =>
      state.userProfile?.userProfile?.email ?? ''
  )

  const isBotAccount =
    !!loggedInUserEmail &&
    (loggedInUserEmail.includes('labra_bot') ||
      loggedInUserEmail.includes('oppsync_bot') ||
      loggedInUserEmail.includes('labra') ||
      loggedInUserEmail.includes('ibexlabs'))

  useEffect(() => {
    if (isInternal === true || isBotAccount) {
      console.debug('Partner is internal or bot, so skipping the tracker')
      setTracker(new Tracker())
      return
    }
    if (
      isInternal === false &&
      !isBotAccount &&
      typeof window !== 'undefined' &&
      window.segmentScriptRun
    ) {
      window.segmentScriptRun(viteSegmentApiWriteKey, serviceEnvironment)
      if (window.analytics) {
        setTracker(new Tracker(window.analytics))
      } else {
        console.error('Unable to load segment')
      }
    } else {
      console.error('Unable to load segment')
    }
  }, [analytics, isInternal, isBotAccount])

  return (
    <TrackerContext.Provider value={tracker}>
      <TrackerLabraAuthProviderBinding />
      {children}
    </TrackerContext.Provider>
  )
}
